import Axios from "axios"
import { store } from "../../../store/store";
import { ServiceEndpoints } from "../../constants/AppConstants";
import { getServerID } from "../CommonUtils";

function getBaseUrl() {
    return ServiceEndpoints[getServerID()]['api']
}

function getHeaders(isJson, attachToken, useUserToken = true) {
    var _headers = {
        "Content-Type": isJson ?
            "application/json" : "multipart/form-data"
    };
    if (attachToken) {
        const reduxState = store.getState();
        if (useUserToken && reduxState.userToken['token']) {
            // logged-in user does not have bearer as per srv impl.
            _headers['Authorization'] = reduxState.userToken['token'];
        } else if (reduxState.guestToken['token']) {
            // guest has bearer
            _headers['Authorization'] = 'Bearer ' + reduxState.guestToken['token'];
        } else return
    }
    return _headers;
}

export function doPost(urn: String, params: any, attachToken: boolean = true) {
    const headers = getHeaders(true, attachToken);
    // if (params?.origin && params.origin == 'localhost:19006' || params.origin == 'lap.mcords.co.in')
    //     params.origin = 'newmedicalstore.mcords.co.in'
    console.log('###, api calling #', urn);
    if (headers) {
        return new Promise((resolve, reject) => {
            Axios.post(getBaseUrl() + urn, JSON.stringify(params), { headers })
                .then(response => {
                    if (response.status == 200) {
                        if (response.data.status == 0)
                            resolve(response.data.data)
                        else reject({ status: response.data.status, msg: response.data.msg })
                    }
                }).catch(error => {
                    if (error.response?.status == 401 || error.response?.status == 403)
                        reject({ status: 401, msg: 'Invalid_token' });
                    else reject({ status: 500, msg: 'Internal error. Please try again.' })
                })
        });
    } else return new Promise((resolve, reject) => {
        reject({ status: 401, msg: 'Undefined auth header' });
    })
}

export function doPostGuest(urn: String, params: any, attachToken: boolean = true) {
    const headers = getHeaders(true, attachToken, false);
    console.log('###, aayu guest api calling #', urn);
    if (headers) {
        return new Promise((resolve, reject) => {
            Axios.post(getBaseUrl() + 'rcb/' + urn, JSON.stringify(params), { headers })
                .then(response => {
                    if (response.status == 200) {
                        if (response.data.status == 0) {
                            resolve(response.data.data)
                        } else {
                            reject(new Error('Something went wrong. Please retry in a while!'));
                        }
                    }
                })
                .catch(error => {
                    console.log(urn, {
                        error,
                        'error status': error.response?.status,
                        'error response': error.response?.data
                    })
                    if (error.response?.status == 401 || error.response?.status == 403) {
                        reject({
                            status: 401,
                            msg: 'Invalid_token'
                        });
                    } else {
                        reject({ status: 500, msg: 'Internal error. Please try again.' })
                    }
                })
        });
    } else {
        return new Promise((resolve, reject) => {
            reject({
                status: 401,
                msg: 'Undefined auth header'
            });
        });
    }
}

export function doMultipart(urn: String, params: Object) {
    const headers = getHeaders(false, true);
    return new Promise((resolve, reject) => {
        Axios.post(getBaseUrl() + urn, params, { headers })
            .then(response => {
                if (response.status == 200) {
                    if (response.data.status == 0) {
                        resolve(response.data.data)
                    } else {
                        reject({ 'errMsg': 'erred!' });
                    }
                } else {
                    reject({ 'errMsg': 'erred!' });
                }
            },
                err => { }
            );
    });
}
